/**
 * O que o painel da Escola Inteligente apresenta sozinho, uma vez (ver
 * `@/Logigate/ui/painel/Novidades`): as novidades do redesenho (outubro de 2026) e os textos do
 * tutorial do casco.
 *
 * Para as próximas novidades: troca-se a lista e sobe-se a `VERSAO_NOVIDADES` em
 * `App\Services\Apresentacao\ApresentacaoDoPainel` (quem já viu estas volta a ver as novas).
 */
import React from "react";
import { PanelLeftClose, School, Search, Sparkles, SunMoon, Users } from "lucide-react";
import type { DiapositivoNovidade, TextosDoTutorial } from "@/Logigate/ui/painel";

export const NOVIDADES_ESCOLA: DiapositivoNovidade[] = [
    {
        chave: "novo-desenho",
        icone: <Sparkles />,
        titulo: "A Escola Inteligente está de cara nova",
        texto: "Um desenho novo, mais limpo e mais rápido, em todas as páginas do painel. Os alunos, as turmas, as notas e as finanças estão nos mesmos sítios do menu.",
    },
    {
        chave: "pesquisa",
        icone: <Search />,
        titulo: "Encontra tudo pela pesquisa",
        texto: "No topo de qualquer página, «Pesquisar…» leva-te directo a uma página ou a uma acção. Ao lado continua «Pesquisar alunos», pelo nome.",
        destaque: "Atalho: ⌘K (Ctrl+K no Windows)",
    },
    {
        chave: "tema",
        icone: <SunMoon />,
        titulo: "Claro, escuro ou como o sistema",
        texto: "O painel acompanha o modo do teu computador ou telemóvel. Podes fixar o claro ou o escuro no botão do tema, no topo, ou no menu da tua conta.",
    },
    {
        chave: "escolas",
        icone: <School />,
        titulo: "Troca de escola no topo do menu",
        texto: "O cartão no topo do menu mostra a escola em que estás. Se geres mais do que uma, em «Trocar» passas para outra, sem voltar a entrar.",
    },
    {
        chave: "portais",
        icone: <Users />,
        titulo: "Os portais também mudaram",
        texto: "Os portais do professor, do aluno e do encarregado foram renovados com o mesmo desenho e o mesmo tema. Podes avisar a tua comunidade escolar.",
    },
    {
        chave: "menu",
        icone: <PanelLeftClose />,
        titulo: "Mais espaço, também no telemóvel",
        texto: "Minimiza o menu para ficar só com os ícones. No telemóvel, a barra de baixo tem o início, os alunos, a pesquisa, os avisos e o menu completo.",
        destaque: "Minimizar o menu: ⌘B (Ctrl+B no Windows)",
    },
];

export const TUTORIAL_ESCOLA: TextosDoTutorial = {
    produto: "Escola Inteligente",
    artigo: "a",
    boasVindas: "Mostramos-te onde fica cada coisa no painel da escola, em menos de um minuto.",
    seletor: {
        titulo: "A tua escola",
        texto: "A escola em que estás a trabalhar. Se geres mais do que uma, em «Trocar» passas para outra.",
    },
    menu: "Os alunos, as turmas, as notas, as finanças e as configurações da escola. Cada grupo abre as suas páginas.",
    extras: [
        {
            alvo: '[data-tour="pesquisar-alunos"]',
            titulo: "Pesquisar alunos",
            texto: "Encontra um aluno pelo nome, a partir de qualquer página.",
        },
    ],
    fim: "Quando precisares, revê este tutorial e as novidades no menu da tua conta. Bom trabalho!",
};
